import React from 'react'

export default function Installation(props) {
  return (
    <section><a className="anchor" id="installation"></a>
      <h2>Getting Started</h2>
      <p><b>Version: 1.28.0.6 Built: 2021-01-12 14:46:58</b></p>

      <h2>Installation</h2>

      <p>Download the latest files available and include them in your build</p>
      <ul className="list-inline">
        <li><a className="btn btn--positive" href="css/commonUI.css" download>commonUI.css</a>&nbsp;</li>
        <li><a className="btn btn--positive" href="css/AG-Grid_theming.css" download>AG-Grid_theming.css</a>&nbsp;</li>
        <li><a className="btn btn--positive" href="js/commonUI.js" download>commonUI.js</a>&nbsp;</li>
        <li><a className="btn btn--positive" href="js/ie11CustomProperties.js" download>ie11CustomProperties.js</a>&nbsp;</li>
      </ul>
      <br/>
      <div className="callout">Optional! Download and include these map files in the same directory as their minified counterparts for better debugging<br/><br/>
        <ul className="list-inline">
          <li><a className="btn" href="css/commonUI.css.map" download>commonUI.css.map</a>&nbsp;</li>
          <li><a className="btn" href="js/commonUI.js.map" download>commonUI.js.map</a></li>
        </ul>
      </div>
      <br/><br/>


      <h2>Adding to your project</h2>
      <p>Include the files along with the Roboto font and FontAwesome in your build like below. </p>
      <p>CSS - </p>
      <pre><code className="language-html">{`<head>
  <meta charset="utf-8">
  <meta http-equiv="x-ua-compatible" content="ie=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <link rel="stylesheet" type="text/css" href="https://fonts.googleapis.com/css?family=Roboto:400,500,700">
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
  <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css">
  <link rel="stylesheet" type="text/css" href="path/to/commonUI.css"/>
</head>`}</code></pre>
      <br/>
      <p>JavaScript - </p>
      <pre><code className="language-html">{`<script type="text/javascript" src="path/to/commonUI.js"></script>`}</code></pre>
      <br/>

      <p>The following polyfill must be used to allow IE11 to use custom properties.</p>
      <pre><code className="language-html">{`<head>
  <script>window.MSInputMethodContext && document.documentMode && document.write('<script type="text/javascript" src="../js/ie11CustomProperties.js"><\x2fscript>');</script>
</head>`}</code></pre>

      <p>Using a sample <a href={props.staticVersion === true ? '#layouts' : 'layouts'}>layout</a> is the recommended starting point.</p>
      <br/><br/>
      <hr/>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Installation.js